import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom'; // Import useLocation
import { message } from 'antd';
import './Estilos/navbar.css';

const NavbarConductor = ({ title }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMenuOpen, setMenuOpen] = useState(window.innerWidth >= 768); // Conditional initial state
  const [isSubMenuOpen, setSubMenuOpen] = useState(false);
  const [email, setEmail] = useState('');

  const menuRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate
  const location = useLocation(); // Initialize useLocation

  useEffect(() => {
    const storedEmail = localStorage.getItem('email');
    if (storedEmail) {
      setEmail(storedEmail);
    }

    // Función para manejar el cambio de tamaño de la ventana
    const handleResize = () => {
      const mobileView = window.innerWidth < 768;
      setIsMobile(mobileView);

      // Si el ancho supera los 768px (vista normal), abrimos el menú automáticamente
      if (!mobileView) {
        setMenuOpen(true);
      }
    };

    // Detectar clic fuera de la barra de navegación solo en pantallas móviles
    const handleClickOutside = (event) => {
      if (isMobile && menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    // Añadir el evento de clic y redimensionamiento de la ventana
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);

    // Limpiar eventos al desmontar el componente
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const toggleSubMenu = () => {
    setSubMenuOpen(!isSubMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario_id');
    localStorage.removeItem('rol_id');
    localStorage.removeItem('email');
    window.location.href = '/';
    message.success('Sesión cerrada exitosamente');
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <div className={`navbar-top-conductor ${location.pathname !== '/conductor' ? 'with-margin' : ''}`}>
        <div className={`hamburger-menu-conductor ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
        <div className="navbar-tittle-conductor">
          <p>{title}</p>
        </div>
        <div className="user-info-conductor">
          <p>Hola, {email}</p>
          <NavLink to="/panel-usuario" className="panel-link-conductor">
            <p className="panel-link-conductor">99Panel</p>
          </NavLink>
          <div className="user-avatar-conductor">
            <img src="/Images/avatar-repartidor.jpg" alt="Avatar" />
          </div>
        </div>
        {location.pathname !== '/conductor' && (
          <button className="back-button-conductor" onClick={handleBack}>Volver</button>
        )}
      </div>
        <div className={`navbar-container-conductor ${isMenuOpen ? 'show' : 'hide'}`} ref={menuRef}>
          <div className="close-btn-conductor" onClick={toggleMenu}>X</div>
          <div className="navbar-title-conductor">
            <img src="/Images/download.png" alt="Download" className="logo-conductor" />
          </div>
          <div className="navbar-menu-conductor">
            <ul>
              <li>
                <NavLink to="/conductor" end activeClassName="active">
                  <span className="material-icons">dashboard</span>Tablero
                </NavLink>
              </li>
              <li>
                <NavLink to="/conductor/ruta-en-espera" end activeClassName="active">
                  <span className="material-icons">pending</span>En espera
                </NavLink>
              </li>
              <li>
                <NavLink to="/conductor/ruta-salir-entregar" end activeClassName="active">
                  <span className="material-icons">local_shipping</span>Salir a Entregar
                </NavLink>
              </li>
              <li>
                <NavLink to="/conductor/entrega-fallida" end activeClassName="active">
                  <span className="material-icons">error_outline</span>Entrega Fallida
                </NavLink>
              </li>
              <li>
                <NavLink to="/conductor/ruta-entregado" end activeClassName="active">
                  <span className="material-icons">check_circle</span>Entregado
                </NavLink>
              </li>
              <li>
                <NavLink to="/conductor/ruta-no-asignado" end activeClassName="active">
                  <span className="material-icons">unpublished</span>No Asignado
                </NavLink>
              </li>
            </ul>
            <a onClick={handleLogout} className="sidebar-item-nav">
              <span className="material-icons">exit_to_app</span>Logout
            </a>
          </div>
        </div>
    </>
  );
};

export default NavbarConductor;